import { render } from "./partner-login-form.vue?vue&type=template&id=44687bdf&ts=true"
import script from "./partner-login-form.vue?vue&type=script&lang=ts"
export * from "./partner-login-form.vue?vue&type=script&lang=ts"

import "./partner-login-form.vue?vue&type=style&index=0&id=44687bdf&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__